import { Grid } from '@mui/material';
import { Fragment } from 'react';
import { developmentLinks, filterNavLinksForAccess } from '../../helpers';
import { ExternalLinkPortalCard, LinkPortalCard, PortalLayout } from '../../components';

export const DevelopmentPortal = () => {
  return (
    <PortalLayout title="Development">
      {({ userContext, featureFlags, availableLinks }) => (
        <>
          {filterNavLinksForAccess(developmentLinks, userContext, featureFlags, availableLinks).map(
            (link, i) => (
              <Fragment key={link.friendlyUrl || link.name}>
                <Grid xs={12} sm={6} md={4} item>
                  {link.featureFlag && !featureFlags[link.featureFlag] ? (
                    <ExternalLinkPortalCard link={link} />
                  ) : (
                    <LinkPortalCard link={link} />
                  )}
                </Grid>
              </Fragment>
            )
          )}
        </>
      )}
    </PortalLayout>
  );
};
